import { Button } from "reactstrap"
import { useNavigate } from 'react-router-dom';

export const WelcomeMessage = ({displayClass = ''}) => {
    const navigate = useNavigate();
    
    return (
        <>
        <div className={`my-auto text-white p-4 welcome-message ${displayClass}`}>
            <h1 className='h3 font-weight-normal libre-caslon-text-regular mb-4'>Collaborative Intelligence (CQ) Inventory</h1>
            <h2 className='font-weight-semibold h4-md h5 mb-3'>An interactive tool for thinking well with those who think differently.</h2>
            <p className='h5-md font-weight-normal'>The Collaborative Intelligence (CQ) Exploration Tool is a 20-minute discovery for improved communication, innovation, problem-solving and team dynamics.</p>
            <hr className='border-white my-4'/>
            <div>
                <p className='h5-md font-weight-normal mb-4'>The initial assessment will help you discover:</p>
                <p className='h5-md mb-3'>Thinking Talents: The ways you think that make you unique.</p>
                <p className='h5-md'>Mind Patterns: What your brain needs to excel at learning.</p>
            </div>
            <Button color="green-light" size="sm" block className='py-2 mb-3 mt-4 d-md-none' onClick={() => {navigate('/login');}}>Let's Sign in</Button>
        </div>
        </>
    )
}
